<template>
  <div class="cantact-us text-xs">
    <div
      class="top pointer rounded cursor-pointer"
      @click="router.push('/demo')"
    >
      <svg-icon name="message" width="16" height="14" class="mb-[5px]" />
      联系我们
    </div>
    <!-- <n-back-top :right="18" /> -->
    <div class="to-top pointer rounded cursor-pointer" @click="scrollToTop">
      <svg-icon name="totop" />
    </div>
  </div>
</template>

<script setup lang="ts">
const router = useRouter()

const scrollToTop = () => {
  // 1) 优先滚动显式内容容器
  const first = document.querySelector(
    '.scroll-container'
  ) as HTMLElement | null
  if (first) {
    if (typeof (first as any).scrollTo === 'function') {
      first.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    } else {
      first.scrollTop = 0
      first.scrollLeft = 0
    }
    return
  }

  // 2) 其次滚动我们标记的外层容器
  const marked = document.querySelector(
    '[data-scroll-container]'
  ) as HTMLElement | null
  if (marked) {
    if (typeof (marked as any).scrollTo === 'function') {
      marked.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    } else {
      marked.scrollTop = 0
      marked.scrollLeft = 0
    }
    return
  }

  // 3) Naive UI 默认内容容器
  const contentEl = document.querySelector(
    '.n-layout-content .n-layout-content__content'
  ) as HTMLElement | null

  if (contentEl) {
    if (typeof (contentEl as any).scrollTo === 'function') {
      contentEl.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    } else {
      contentEl.scrollTop = 0
      contentEl.scrollLeft = 0
    }
  } else {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    } catch {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.cantact-us {
  position: fixed;
  margin-right: 18px;
  right: 0;
  top: 325px;
  width: 36px;
  color: white;
  .top {
    background: var(--primary);
    padding: 10px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      background: #0d56e8;
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px 0px rgba(14, 97, 254, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }
  .to-top {
    width: 36px;
    height: 36px;
    margin-top: 12px;
    background: #ffffff;
    box-shadow: 0px 1px 5px 0px rgba(34, 71, 152, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover {
      background: #f0f0f0;
      transform: translateY(-2px);
      box-shadow: 0px 3px 8px 0px rgba(34, 71, 152, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>
